<!--
    描述:骨架屏 数组未加载站位图  已全局引用，

    参数:  isBanner  ,是否显示banner 默认隐藏
          isList  ,是否显示列表 默认显示
          listLength  ,列表长度 默认30

    作者:zly
 -->
<template>
  <div class="skeleton">
    <div class="box">
      <div class="skeleton_banner" v-if="isBanner">
        <img :src="$store.state.manyCompany.skeleton_bg1200" alt srcset />
      </div>
      <div class="list" v-for="(item, index) in list" v-if="isList" :key="index">
        <div class="border">
          <div class="list_top">
            <img src="/static/images/bg800.png" alt />
          </div>
          <div class="list_center"></div>
          <div class="list_botttom"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    // isBanner: {
    //   //是否显示banner 默认隐藏
    //   type: Boolean,
    //   default: false
    // },
    isList: {
      //是否显示列表 默认显示
      type: Boolean,
      default: true
    },
    listLength: {
      //列表长度 默认30
      type: Number,
      default: 30
    }
  },
  data() {
    return {
        isBanner:false,
      list: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1] //图片列表的长度
    };
  },
  mounted() {
    this.list = new Array(this.listLength);
  },
  methods: {}
};
</script>
<style lang="less" scoped>
.skeleton {
  width: 100%;
  .box {
    width: 1200px;
    background: #fff;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin: 30px auto;
    .skeleton_banner {
      width: 1180px;
      margin: 10px auto;
      border: solid 1px #ccc;
    }

    .list {
      width: 240px;
      height: 362px;
      text-align: center;
      overflow: hidden;
      .border {
        width: 220px;
        height: 342px;
        box-sizing: border-box;
        border: solid 1px #ccc;
        margin: 10px auto;
      }
      // margin: 30px 0;
      .list_top {
        width: 180px;
        height: 180px;
        margin: 30px auto;
        background: #f9f9f9;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .list_center {
        width: 180px;
        height: 20px;
        margin: 0 auto 30px auto;
        background: #eee; // 260
      }
      .list_botttom {
        //
        width: 180px;
        height: 32px;
        margin: 0 auto;
        background: #eee;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/skeleton.vue